module.exports = {
  siteTitle: "Berlin Robotics", // Site title.
  siteTitleAlt: "Berlin Robotics Meetup", // Alternative site title for SEO.
  siteLogo:
    "https://haysclark.github.io/gatsby-starter-casper/logos/logo-1024.png", // Logo used for SEO and manifest. e.g. "/logos/logo-1024.png",
  siteUrl: "https://berlin-robotics.github.io", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-casper/.
  siteDescription:
    "This is the official site for the Berlin Robtics Meetup.", // Website description used for RSS feeds/meta description tag.
  // Optional, the cover image used in header for home page. e.g: "/images/blog-cover.jpg",
  siteNavigation: true, // If navigation is enabled the Menu button will be visible
  
  googleAnalyticsID: "UA-xxxxxx167-1", // GA tracking ID.

  postDefaultCategoryID: "Tech", // Default category for posts.
  // Copyright string for the footer of the website and RSS feed.
  copyright: {
    label: "Bits and Bytes will create this site but hardware lasts forever!" // Label used before the year
    // year: "2018" // optional, set specific copyright year or range of years, defaults to current year
    // url: "https://www.gatsbyjs.org/" // optional, set link address of copyright, defaults to site root
  },
  themeColor: "#c62828", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0", // Used for setting manifest background color.
  promoteGatsby: true // Enables the GatsbyJS promotion information in footer.
};